import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  forgotUsername: string | null;
}

const initialState: AuthState = {
  forgotUsername: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setForgotUsername: (state, action: PayloadAction<string>) => {
      state.forgotUsername = action.payload;
    },
    clearForgotUsername: (state) => {
      state.forgotUsername = null;
    },
  },
});

export const { setForgotUsername, clearForgotUsername } = authSlice.actions;

export default authSlice.reducer;
